import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

const finePrintStyles = css({
    color: "#6C6F77",
    margin: `${token("space.400")} 0`
});

export const GartnerDisclaimer = () => (
    <UFOSegment name="enterprise-page-disclaimer">
        <Row>
            <p css={finePrintStyles} className="fine-print">
                <FormattedMessage
                    id="EnterpriseLandingPage.gartnerDisclaimer"
                    defaultMessage="* Gartner, Magic Quadrant for DevOps Platforms, Manjunath Bhat, Thomas Murphy, Joachim Herschmann, Daniel Betts, Chris Saunderson, Hassan Ennaciri, Bill Holz, Peter Hyde, 5 June 2023. 
                    {br}{br}
                    Gartner, Magic Quadrant for Enterprise Agile Planning Tools, Bill Blosen, Mike West, Keith Mann, Deacon D.K Wan, Akis Sklavounakis, Hassan Ennaciri, Sarah Davies, 25 April 2022. 
                    {br}{br}
                    Gartner, Voice of the Customer for Enterprise Agile Planning Tools, By Peer Contributors, 13 December 2023. 
                    {br}{br}
                    Gartner does not endorse any vendor, product or service depicted in its research publications, and does not advise technology users to select only those vendors with the highest ratings or other designation. Gartner research publications consist of the opinions of Gartner’s research organization and should not be construed as statements of fact. Gartner disclaims all warranties, expressed or implied, with respect to this research, including any warranties of merchantability or fitness for a particular purpose. 
                    {br}{br}
                    Gartner Peer Insights content consists of the opinions of individual end users based on their own experiences with the vendors listed on the platform, should not be construed as statements of fact, nor do they represent the views of Gartner or its affiliates. Gartner does not endorse any vendor, product or service depicted in this content nor makes any warranties, expressed or implied, with respect to this content, about its accuracy or completeness, including any warranties of merchantability or fitness for a particular purpose. 
                    {br}{br}
                    GARTNER is a registered trademark and service mark, and the GARTNER PEER INSIGHTS CUSTOMERS’ CHOICE badge, MAGIC QUADRANT and PEER INSIGHTS are trademarks and service marks, of Gartner, Inc. and/or its affiliates in the U.S. and internationally and are used herein with permission. All rights reserved."
                    values={DEFAULT_VALUES}
                />
            </p>
        </Row>
    </UFOSegment>
);
